import styled from "styled-components";
import { Link } from "react-router-dom";
import { fixArabicText } from "../../helpers/text";
import { truncateTOC, isTOCIndented } from "../../helpers/toc";

const List = styled.div<{ isChild: boolean }>`
    user-select: none;
    display: block;
    margin-top: ${(p) => (p.isChild ? 10 : 0)}px;

    &:first-of-type {
    }

    [lang="ar"] {
        font-size: 15px;
    }
`;
const Item = styled.div<{ indent: number; heading: boolean }>`
    position: relative;
    min-height: 30px;
    padding-right: ${(p) => (p.indent > 0 ? p.indent * 18 : 0)}px;
    font-family: urdu, QuranFont, Roboto, sans-serif;

    a {
        text-decoration: none;
    }

    & > a {
        font-size: ${(p) => (p.heading ? 16 : 16)}px;
        font-weight: ${(p) => (p.heading ? 700 : 500)};

        [text="ؐ"],
        [text="ؑ"] {
            font-size: 10px;
        }

        &:hover {
            font-weight: 500;
        }
    }
`;
const Index = styled.span<{ heading: boolean }>`
    position: relative;
    display: inline-block;
    right: -10px;
    top: 1px;
    min-width: 25px;
    font-family: urdu;
    font-size: ${(p) => (p.heading ? 16 : 14)}px;
    font-weight: 500;
    text-align: left;
`;

function children(list: Array<Page>, pages: Array<Page>, parent_id: number) {
    for (let i = 0; i < pages.length; i += 1) {
        const p = pages[i];

        if (parent_id === p.parent_id) {
            p.children = children([], pages, p.id);
            list.push(p);
        }
    }

    return list;
}

type Props = {
    list: Array<Page>;
    prefix: string;
    indent: number;
    indented: boolean;
};

function Chapters({ list, prefix, indented, indent }: Props) {
    return (
        <List isChild={prefix.toString().length > 0}>
            {list.map(({ id, link, title, children }: Page, i) => {
                let n = prefix ? `${prefix}.${i + 1}` : (i + 1).toString();
                let heading = indent === 0;
                if (heading && !indented) {
                    heading = false;
                }

                return (
                    <Item key={`li-${id}`} indent={indent} heading={heading}>
                        <Index heading={heading}>{n}</Index>
                        <Link
                            to={link}
                            dangerouslySetInnerHTML={fixArabicText(title)}
                        />
                        {children.length > 0 && (
                            <Chapters
                                list={children}
                                prefix={n}
                                indent={indent + 1}
                                indented={indented}
                            />
                        )}
                    </Item>
                );
            })}
        </List>
    );
}

export interface Page {
    _indent: number;
    parent_id: number;

    id: number;
    link: string;
    name: string;
    title: string;
    position: number;
    children: Array<Page>;
}

interface TOC {
    pages: Array<Page>;
}

export default function TableOfContents({ pages }: TOC) {
    const list = truncateTOC(pages) as Array<Page>;

    return (
        <Chapters
            prefix=""
            indent={0}
            indented={isTOCIndented(list)}
            list={children([], list, 0)}
        />
    );
}
